// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryImage__root--1iuS-","placeholder":"PrimaryImage__placeholder--3iwOn","img":"PrimaryImage__img--1-OFA"};